import { Filter } from '@dfl/mui-admin-layout';
import { createdATFilter } from 'modules/common/constants';
import { disabledActionTaken } from 'utils/flags-utils';
import {
  orderCodeFilter,
  orderEmailFilter,
  orderStatusFilter,
  orderDeliveryDueFilter,
  orderProductItemsFilter,
  orderTotalAmountFilter,
  orderTotalItemsFilter,
  orderTotalProductsFilter,
  paymentGatewayFilter,
  paymentMethodFilter,
  orderOfferFilter,
  shippingAddressFilter,
  orderIncidencesFilter,
  orderCodeProductFilter,
  orderPaymentDateFilter,
  orderSupplierFilter,
  orderActionTakenFilter,
  orderProductsAmountFilter,
} from 'modules/sales/common/constants/order-filters';

export const paidOrderFilters: Filter[] = [
  orderCodeFilter,
  orderEmailFilter,
  orderStatusFilter,
  orderOfferFilter,
  orderIncidencesFilter,
  orderTotalProductsFilter,
  orderProductsAmountFilter,
  orderDeliveryDueFilter,
  ...shippingAddressFilter,
  orderSupplierFilter,
  orderTotalAmountFilter,
  paymentGatewayFilter,
  paymentMethodFilter(),
  orderTotalItemsFilter,
  orderProductItemsFilter,
  orderCodeProductFilter,
  orderPaymentDateFilter,
  createdATFilter,
  ...(disabledActionTaken ? [] : [orderActionTakenFilter]),
];

export const defaultPaidOrderFilterKeys: Filter[] = [
  orderCodeFilter,
  orderEmailFilter,
  orderStatusFilter,

  orderTotalProductsFilter,
  orderProductsAmountFilter,
  orderDeliveryDueFilter,

  ...shippingAddressFilter,
  orderSupplierFilter,

  orderTotalAmountFilter,
  paymentGatewayFilter,
  paymentMethodFilter(),
  orderTotalItemsFilter,
  orderProductItemsFilter,
  orderPaymentDateFilter,
  ...(disabledActionTaken ? [] : [orderActionTakenFilter]),
];
